type WaitForElementOptions = {
  timeout?: number;
  intervalMs?: number;
  signal?: AbortSignal;
};

export const waitForElement = (
  selector: string,
  { timeout = 2000, intervalMs = 50, signal }: WaitForElementOptions = {},
): Promise<Element | null> =>
  new Promise((resolve) => {
    if (signal?.aborted) {
      resolve(null);
      return;
    }

    const existing = document.querySelector(selector);
    if (existing) {
      resolve(existing);
      return;
    }

    const start = performance.now();
    const interval = window.setInterval(() => {
      if (signal?.aborted) {
        window.clearInterval(interval);
        resolve(null);
        return;
      }
      const el = document.querySelector(selector);
      if (el) {
        window.clearInterval(interval);
        resolve(el);
        return;
      }
      if (performance.now() - start > timeout) {
        window.clearInterval(interval);
        resolve(null);
      }
    }, intervalMs);

    signal?.addEventListener(
      'abort',
      () => {
        window.clearInterval(interval);
        resolve(null);
      },
      { once: true },
    );
  });
